/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientFirstSessionDto } from './ClientFirstSessionDto';
import type { ClientSessionBookingDto } from './ClientSessionBookingDto';
import type { ClientSessionExpertDto } from './ClientSessionExpertDto';
import type { ClientSessionLocationDto } from './ClientSessionLocationDto';
import type { ClientSessionRescheduleDto } from './ClientSessionRescheduleDto';
import type { ClientSessionServiceDto } from './ClientSessionServiceDto';
export type ClientSessionDetailResponseDto = {
    /**
     * Session UUID
     */
    id: string;
    /**
     * Session number
     */
    sessionNumber: number;
    /**
     * Scheduled start time
     */
    scheduledStartTime: string;
    /**
     * Scheduled end time
     */
    scheduledEndTime: string;
    /**
     * Actual start time
     */
    actualStartTime?: string | null;
    /**
     * Actual end time
     */
    actualEndTime?: string | null;
    /**
     * Session status
     */
    status: ClientSessionDetailResponseDto.status;
    /**
     * Session mode
     */
    mode?: ClientSessionDetailResponseDto.mode;
    /**
     * Session notes
     */
    sessionNotes?: string | null;
    /**
     * Meeting link for online sessions
     */
    meetingLink?: string | null;
    /**
     * Attendance status
     */
    attendanceStatus?: ClientSessionDetailResponseDto.attendanceStatus;
    /**
     * Rejection reason for attendance
     */
    rejectionReason?: string | null;
    /**
     * Attendance marked at timestamp
     */
    attendanceMarkedAt?: string | null;
    /**
     * Attendance accepted at timestamp
     */
    attendanceAcceptedAt?: string | null;
    /**
     * User UUID who cancelled the session
     */
    cancelledBy?: string | null;
    /**
     * Cancellation reason
     */
    cancellationReason?: string | null;
    expert: ClientSessionExpertDto;
    booking: ClientSessionBookingDto;
    service: ClientSessionServiceDto;
    location?: ClientSessionLocationDto;
    latestReschedule?: ClientSessionRescheduleDto;
    firstSession?: ClientFirstSessionDto | null;
};
export namespace ClientSessionDetailResponseDto {
    /**
     * Session status
     */
    export enum status {
        SCHEDULED = 'scheduled',
        IN_PROGRESS = 'in_progress',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled',
        RESCHEDULED = 'rescheduled',
    }
    /**
     * Session mode
     */
    export enum mode {
        ONLINE = 'online',
        CLIENT_LOCATION = 'client_location',
        EXPERT_LOCATION = 'expert_location',
    }
    /**
     * Attendance status
     */
    export enum attendanceStatus {
        PENDING = 'pending',
        MARKED = 'marked',
        ACCEPTED = 'accepted',
        REJECTED = 'rejected',
    }
}

